import type { ResourceArticle } from '~/types/ResourceArticle'

export const traumaAndPTSDArticle: ResourceArticle = {
  uid: 'trauma-post-traumatic-stress',
  thumbnailImageUrl: 'https://cdn.hubofhope.co.uk/public/img/thumbs/RESOURCES_T%2BPTS_800x800.jpg',
  thumbnailImageAlt: 'Trauma',
  title: 'Trauma & post-traumatic stress',
  supportNeedCategoryLabel: 'Trauma',
  supportNeedCategoryUid: 'EcZDqRm8dcLeclsJi684',
  isFeatured: true,
  excerpt:
    'Terrible events and circumstances are very hard to deal with. Grief, numbness, anger, anxiety and shame are all very common reactions to traumatic events such as a serious road accident or a violent personal assault – and also to ongoing traumatic experiences such as domestic violence or homelessness, or childhood experiences of abuse or neglect.',
  content: `
  <div class="prose mt-4">
    <p class="font-bold">
      Terrible events and circumstances are very hard to deal with. Grief, numbness, anger, anxiety and shame are all very common reactions to traumatic events such as a serious road accident or a violent personal assault – and also to ongoing traumatic experiences such as domestic violence or homelessness, or childhood experiences of abuse or neglect.
    </p>
  
    <h2 class="font-semibold text-lg font-brown text-primary mt-8">Aftermath of trauma</h2>
    <p>
      In the aftermath of trauma we may often find it hard to sleep. We may experience nightmares and flashbacks, particularly when something happens that reminds us of the event or situation. If the trauma has happened in the context of a close relationship it can be hard to trust people again, and we may feel anxious and on high alert when we are with others. There might be physical impacts such as chronic pain, body tension or numbness. We may also feel low, despairing and helpless.
    </p>
  
    <p class="mt-4">
      These experiences are sometimes called PTSD or complex PTSD – post-traumatic stress disorder.
    </p>
  
    <figure class="my-8">
      <img src="https://cdn.hubofhope.co.uk/public/img/thumbs/vladimir-fedotov-cwNHnU4IB8w-unsplash_800x800.jpg"
           alt="Trauma article image" 
           class="max-w-md w-full h-auto rounded shadow-md mx-auto">
    </figure>
  
    <h2 class="font-semibold text-lg font-brown text-primary mt-8">Finding help</h2>
    <p class="mb-8">
      In terms of help, different things help different people. Often practical things such as self-care are central, including exercise, eating and sleeping well. Doing things that connect us with others, including people with similar experiences, either informally or in organised peer support groups can be a big help. Therapy or counselling can help us find ways to regulate our physical and emotional states, and provide a safe space to process traumatic memories, helping us to separate the past from the present. It can also help us to process feelings of shame – an extremely common reaction to trauma. GPs should also be able to provide referrals to specialist trauma services.
    </p>
  </div>`
}
